import {Chip, FormLabel, IconButton} from '@mui/material';
import React, {useEffect, useState} from 'react';
import useOpenState from '../../../../hooks/useOpenState';
import {useDispatch, useSelector} from 'react-redux';
import {announcements, loadAnnouncements} from '../../../../store/reducers/announcement';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Badge from '@mui/material/Badge';
import AgyleDialog from '../../../../components/modal/agyleDialog';
import {useTranslation} from 'react-i18next';
import InformationBox from '../../../../components/other/informationBox';
import {TimerCountUp} from '../../../../controls/agyle/timer';
import _, {isEmpty} from 'lodash';
import API from '../../../../app/api';
import {setSnackbar} from '../../../../store/reducers/globals';
import {Tooltip} from '@material-ui/core';
import {useHeaderIconStyles} from '../../../../components/patient/components/iconStyle';
import clsx from 'clsx';

const WardAlerts = ({ward}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const classes = useHeaderIconStyles();

    // Announcements
    const announcementsObject = useSelector(announcements);
    const [filtered, setFiltered] = useState([]);
    const [wardEscalations, setWardEscalations] = useState([]);

    const [isAlertsOpen, openAlerts, closeAlerts] = useOpenState(false, false);

    // Refresh Announcements every 1 minute
    useEffect(() => {
        dispatch(loadAnnouncements());
        const iid = setInterval(() => dispatch(loadAnnouncements()), 60000);
        return () => {
            clearInterval(iid);
        };
    }, []);

    useEffect(() => {
        const filter = announcementsObject?.filter(a => a.enabled && a.system !== 'UCR' && a.system !== 'ED WAIT');
        setFiltered(filter);
    }, [announcementsObject]);

    useEffect(() => {
        let iid;
        if (ward) {
            getEscalation();
            iid = setInterval(getEscalation, 60000);
        }
        return () => {
            clearInterval(iid);
        };
    }, [ward]);

    const getEscalation = () => {
        API.getEscalationLevels(ward?.hospitalId)
            .then(res => {
                const alerts = [];
                _.forEach(ward?.wardsId, id => {
                    const find = _.find(res, {wardId: id});
                    if (find && find?.level !== 'core') {
                        alerts.push(find);
                    }
                });
                setWardEscalations(alerts);
            })
            .catch(() => {
                dispatch(setSnackbar({type: 'error', message: t('Unable to retrieve escalation levels.')}));
            });
    };

    const renderAnnouncement = (obj) => {
        return (
            <InformationBox type="warning-white" key={obj?.id}>
                {obj?.text || ''}

                {(obj?.counter && obj?.countdownTo) &&
                    <TimerCountUp
                        time={obj?.countdownTo}
                        limit={0}
                        upperLimit={1}
                        limitMessage={t('Times out')}
                        countDown
                    />
                }
            </InformationBox>
        );
    };

    const renderWardEscalation = (ward) => {
        return (
            <InformationBox type="warning-white" key={ward?.__id}>
                <div style={{display: 'flex', gap: 10}}>
                    <FormLabel>
                        {t('Ward Id')}
                    </FormLabel>

                    <Chip
                        label={ward?.wardId}
                        size="small"
                        sx={{mr: 1}}
                    />

                    <FormLabel>
                        {t('Current Escalation Level')}
                    </FormLabel>

                    <Chip
                        label={_.capitalize(ward?.level)}
                        size="small"
                        sx={{mr: 1}}
                    />
                </div>

                <div>
                    {t('Escalation level beds are now available for ward. Please refresh browser if not present.')}
                </div>
            </InformationBox>
        );
    };

    return (
        <>
            <Tooltip title={t('Ward Alerts')}>
                <IconButton
                    size="small"
                    onClick={openAlerts}
                    color={(isAlertsOpen) ? 'primary' : 'default'}
                    className={clsx(classes.iconHover, (isAlertsOpen) && classes.iconButton)}
                >
                    <Badge
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        max={9}
                        badgeContent={(filtered?.length || 0) + (wardEscalations?.length || 0)}
                        color={!_.isEmpty(wardEscalations) ? 'error' : 'primary'}
                        sx={{'& .MuiBadge-badge': {fontSize: 11, height: 15, minWidth: 15}}}
                    >
                        <WarningAmberIcon/>
                    </Badge>
                </IconButton>
            </Tooltip>

            {isAlertsOpen &&
                <AgyleDialog
                    title={t('Ward Alerts')}
                    open={isAlertsOpen}
                    onClose={closeAlerts}
                    onSave={closeAlerts}
                    width="md"
                    fullWidth
                    disableActionsCloseButton
                    submitText={t('Acknowledge')}
                    closeButtonOnHeader
                >
                    <>
                        {wardEscalations.map(a => renderWardEscalation(a))}
                        {filtered.map(a => renderAnnouncement(a))}
                        {(isEmpty(filtered) && isEmpty(wardEscalations)) &&
                            <InformationBox type="info">
                                {t('There are currently no alerts available.')}
                            </InformationBox>
                        }
                    </>
                </AgyleDialog>
            }
        </>
    );
};

export default WardAlerts;